import { Component, Input, OnInit } from '@angular/core';

/**
 * ID: bh-message-banner
 * Name: BH Message Banner
 * Description: A standardized message block used for displaying important user information
 * Version: 3
 *
 * ==============================
 * Change Log
 * ==============================
 * 2021-06-23 - MW - v1: Initial dev
 * 2021-07-12 - MW - v2: Adjust margin and icon size
 * 2022-05-09 - MW - v3: Minor style adjustments
 */
@Component({
  selector: 'bh-message-banner',
  templateUrl: './bh-message-banner.component.html',
  styleUrls: ['./bh-message-banner.component.scss'],
})
export class BhMessageBannerComponent implements OnInit {
  @Input() ionIcon;
  @Input() ionIconColor;
  @Input() type: 'information' | 'warning' | 'success' | 'danger';

  constructor() { }

  ngOnInit() {}

}
